import { lazy } from 'react';
import Loadable from '../../components/Loadable';

const PodStatement = Loadable(lazy(() => import('./PodStatement')));
const PodStReport = Loadable(lazy(() => import('./PodStReport')));
const DemoScan = Loadable(lazy(() => import('./DemoScan')));
const CheckPod = Loadable(lazy(() => import('./CheckPod')));
const PendingPodReport = Loadable(lazy(() => import('./PendingPodReport')));

const PodRoutes = [
  { path: '/checkpod', element: <CheckPod /> },
  { path: '/pendingpodreport', element: <PendingPodReport /> },
  { path: '/podstatement', element: <PodStatement /> },
  { path: '/podstatementreport', element: <PodStReport /> },
  { path: '/demoscan', element: <DemoScan /> },
];

export default PodRoutes;
